// Icons Import
import { ReactComponent as BusinessIcon } from "&/img/markers/pois/iconFilled/business_iconFilled.svg";
import { ReactComponent as AnchorageIcon } from "&/img/markers/pois/iconFilled/anchorage_iconFilled.svg";
import { ReactComponent as ArtificialReefIcon } from "&/img/markers/pois/iconFilled/artificialReef_iconFilled.svg";
import { ReactComponent as BoatRampIcon } from "&/img/markers/pois/iconFilled/boatRamp_iconFilled.svg";
import { ReactComponent as BeachIcon } from "&/img/markers/pois/iconFilled/beach_iconFilled.svg";
import { ReactComponent as BridgeIcon } from "&/img/markers/pois/iconFilled/bridge_iconFilled.svg";
import { ReactComponent as CityTownIcon } from "&/img/markers/pois/iconFilled/cityTown_iconFilled.svg";
import { ReactComponent as ClubAssociationIcon } from "&/img/markers/pois/iconFilled/clubAssociation_iconFilled.svg";
import { ReactComponent as DamIcon } from "&/img/markers/pois/iconFilled/dam_iconFilled.svg";
import { ReactComponent as DockBarRestaurantIcon } from "&/img/markers/pois/iconFilled/dockBar_iconFilled.svg";
import { ReactComponent as FreeDockIcon } from "&/img/markers/pois/iconFilled/docking_iconFilled.svg";
import { ReactComponent as FishingSpotIcon } from "&/img/markers/pois/iconFilled/fishingSpot_iconFilled.svg";
import { ReactComponent as LightHouseIcon } from "&/img/markers/pois/iconFilled/lightHouse_iconFilled.svg";
import { ReactComponent as MooringIcon } from "&/img/markers/pois/iconFilled/mooring_iconFilled.svg";
import { ReactComponent as HotelIcon } from "&/img/markers/pois/iconFilled/hotel_iconFilled.svg";
import { ReactComponent as InletIcon } from "&/img/markers/pois/iconFilled/inlet_iconFilled.svg";
import { ReactComponent as LockIcon } from "&/img/markers/pois/iconFilled/lock_iconFilled.svg";
import { ReactComponent as MarinaIcon } from "&/img/markers/pois/iconFilled/marina_iconFilled.svg";
import {
  ReactComponent as OtherIcon,
  ReactComponent as MyLocationIcon,
} from "&/img/markers/pois/iconFilled/other_iconFilled.svg";
import { ReactComponent as RestaurantBarIcon } from "&/img/markers/pois/iconFilled/restaurantBar_iconFilled.svg";
import { ReactComponent as YachtClubIcon } from "&/img/markers/pois/iconFilled/yachtClub_iconFilled.svg";
import { ReactComponent as BoatClubIcon } from "&/img/markers/pois/iconFilled/boatClub_iconFilled.svg";
import { ReactComponent as PrivateDockIcon } from "&/img/markers/pois/iconFilled/privateDock_iconFilled.svg";
import { ReactComponent as PointofInterestIcon } from "&/img/markers/pois/iconFilled/pointOfInterest_iconFilled.svg";
import { IconKeysPois } from "@/types/markers";

export const getPoiIconWaypoint = (type: IconKeysPois) => {
  switch (type) {
    case IconKeysPois.Anchorage:
      return AnchorageIcon;
    case IconKeysPois.ArtificialReef:
      return ArtificialReefIcon;
    case IconKeysPois.Beach:
      return BeachIcon;
    case IconKeysPois.BoatClub:
      return BoatClubIcon;
    case IconKeysPois.BoatRamp:
      return BoatRampIcon;
    case IconKeysPois.BoatRamp2:
      return BoatRampIcon;
    case IconKeysPois.Bridge:
      return BridgeIcon;
    case IconKeysPois.BridgeClearance:
      return BridgeIcon;
    case IconKeysPois.Business:
      return BusinessIcon;
    case IconKeysPois.CityTown:
      return CityTownIcon;
    case IconKeysPois.ClubAssociation:
      return ClubAssociationIcon;
    case IconKeysPois.Dam:
      return DamIcon;
    case IconKeysPois.DockBarRestaurant:
      return DockBarRestaurantIcon;
    case IconKeysPois.FishingSpot:
      return FishingSpotIcon;
    case IconKeysPois.FreeDock:
      return FreeDockIcon;
    case IconKeysPois.Hotel:
      return HotelIcon;
    case IconKeysPois.Inlet:
      return InletIcon;
    case IconKeysPois.LightHouse:
      return LightHouseIcon;
    case IconKeysPois.Lock:
      return LockIcon;
    case IconKeysPois.Marina:
      return MarinaIcon;
    case IconKeysPois.Mooring:
      return MooringIcon;
    case IconKeysPois.MyLocation:
      return MyLocationIcon;
    case IconKeysPois.Other:
      return OtherIcon;
    case IconKeysPois.PointOfInterest:
      return PointofInterestIcon;
    case IconKeysPois.PrivateDock:
      return PrivateDockIcon;
    case IconKeysPois.RestaurantBar:
      return RestaurantBarIcon;
    case IconKeysPois.YachtClub:
      return YachtClubIcon;
    default:
      return OtherIcon;
  }
};
